import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageSpinner } from '@app/components';
import { useAccountActivation, useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { accountActivationStatus, Route } from '@app/constants';

export const AccountActivationPage: FC = () => {
  const navigate = useNavigate();
  const { token } = useQueryParams();
  const { mutate: activateAccount } = useAccountActivation();

  useEffect(() => {
    if (token) {
      activateAccount(token as string, {
        onSuccess: () =>
          navigate(
            generateRouteParams({
              pathname: Route.directLogin,
              query: {
                status: accountActivationStatus.activated,
              },
            })
          ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PageSpinner />;
};
